import clsx from 'clsx';
import * as React from 'react';
import { ChangeEvent } from 'react';
import SearchIcon from '../icons/SearchIcon';

interface SearchProps {
    search: string;
    setSearch: (search: string) => void;
    placeholder?: string;
}

export default function Search({
    search,
    setSearch,
    placeholder,
}: SearchProps) {
    function handleSearch({
        target: { value },
    }: ChangeEvent<HTMLInputElement>) {
        setSearch(value);
    }

    return (
        <div className={clsx('control control--search')}>
            <div className="icon">
                <SearchIcon />
            </div>
            <input
                type="text"
                value={search}
                placeholder={placeholder}
                onChange={handleSearch}
            />
        </div>
    );
}
